import { EyeShowIcon } from '@rsos/base-assets/icons';
import { Box, Text } from '@rsos/base-components';
import Popover from '@rsos/components/capstone/base/Popover';
import { useFlag } from '@rsos/flags';
import { LayerName } from '../LayerOpacityControl.styles';
import { Wrapper } from './LayerOpacityControl.styles';
import { OpacitySlider } from './OpacitySlider';
import { usePopoverControls } from './usePopoverControls';

export const opacityControlWidth = 200;

interface LayerProps {
  layerId: number;
  layerName?: string;
}

interface SublayerProps {
  sublayerId: string;
  layerName?: string;
}

export const LayerOpacityControl = (props: LayerProps | SublayerProps) => {
  const isSublayer = 'sublayerId' in props;

  const id = isSublayer ? props.sublayerId : String(props.layerId);

  const name = props.layerName;

  const { isOpen, open, close } = usePopoverControls(id);

  const isEnabled = useFlag('layers-opacity-controls');

  if (!isEnabled) {
    return null;
  }

  return (
    <Box horizontal marginRight="9px">
      <Popover
        trigger={
          <Box
            onClick={open}
            onMouseLeave={close}
            align="center"
            justify="center"
            marginLeft={2}
            cursor="pointer"
          >
            <EyeShowIcon color="secondaryText" width={15} height={15} />
          </Box>
        }
        isOpen={isOpen}
        popoverID="example-popover"
        xOffset={-opacityControlWidth}
        yOffset={20}
      >
        <Wrapper
          width={`${opacityControlWidth}px`}
          onMouseEnter={open}
          onMouseLeave={close}
        >
          <Box marginBottom={1} horizontal>
            <LayerName size="small" color="secondaryText">
              {name}
            </LayerName>
            <Text size="small" color="secondaryText">
              opacity
            </Text>
          </Box>
          {isSublayer && <OpacitySlider sublayerId={props.sublayerId} />}
          {!isSublayer && <OpacitySlider layerId={props.layerId} />}
        </Wrapper>
      </Popover>
    </Box>
  );
};
